const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const getImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};
